import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import { reset } from 'redux-form';
import List from './List';
import Summary from './Summary';
import Filter from './Filter';
import {
	loadCampaignStats, loadCampaignStatsDetails, exportCampaignStats,
	CAMPAIGN_STATS_REQUEST, CAMPAIGN_STATS_SUCCESS, CAMPAIGN_STATS_FAILURE,
	CAMPAIGN_STATS_DETAILS_REQUEST, CAMPAIGN_STATS_DETAILS_SUCCESS, CAMPAIGN_STATS_DETAILS_FAILURE
} from './actions';
import { initialize } from 'redux-form';
import ReduxBlockUi from 'react-block-ui/redux';

class CampaignStats extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEventDetails = this.handleListEventDetails.bind(this);
		this.handleListEventSummary = this.handleListEventSummary.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.campaignStatsPagination;
		const { sortKeyDetails, sortDirectionDetails } = this.props.campaignStatsDetailsPagination;
		const pageNumberDetails = this.props.campaignStatsDetailsPagination.pageNumber;
		const pageSizeDetails = this.props.campaignStatsDetailsPagination.pageSize;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize, sortKeyDetails, sortDirectionDetails, pageNumberDetails, pageSizeDetails });
		this.props.initializeFilter(filter);
	}

	handleFilterSubmit(options) {
		const { exportFormat, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.campaignStatsPagination;
		const { sortKeyDetails, sortDirectionDetails } = this.props.campaignStatsDetailsPagination;
		const pageSizeDetails = this.props.campaignStatsDetailsPagination.pageSize;

		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize, sortKeyDetails, sortDirectionDetails, pageNumberDetails: 1, pageSizeDetails });
		if (exportFormat)
			this.exportData(filter);
	}

	handleListEventDetails(listPagination) {
		const { filter } = this.props.campaignStatsPagination;
		const { loadCampaignStatsDetails } = this.props;
		loadCampaignStatsDetails({ ...filter, sortKey: listPagination.sortKey, sortDirection: listPagination.sortDirection, pageSize: listPagination.pageSize, pageNumber: listPagination.pageNumber });

	}

	handleListEventSummary(listPagination) {
		const { filter } = this.props.campaignStatsPagination;
		const { loadCampaignStats } = this.props;
		loadCampaignStats({ ...filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize, sortKeyDetails, sortDirectionDetails, pageNumberDetails, pageSizeDetails }) {
		const { loadCampaignStats, loadCampaignStatsDetails } = this.props;
		loadCampaignStats({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
		loadCampaignStatsDetails({ ...filter, sortKey: sortKeyDetails, sortDirection: sortDirectionDetails, pageSize: pageSizeDetails, pageNumber: pageNumberDetails });
	}

	exportData(filter) {
		this.props.exportCampaignStats(filter);
	}

	render() {
		const { data, details, t } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					loading={this.props.campaignStatsDetailsPagination.loading || this.props.campaignStatsExport.loading}
				/>

				<Tabs defaultActiveKey={2} id='report-parent-tabs'>
					<Tab eventKey={1} title={t('CampaignStats_Tab_Details')}>
						<ReduxBlockUi block={CAMPAIGN_STATS_DETAILS_REQUEST} unblock={[CAMPAIGN_STATS_DETAILS_SUCCESS, CAMPAIGN_STATS_DETAILS_FAILURE]}>
							<List
								data={details}
								onFetchData={this.handleListEventDetails}
								{...this.props.campaignStatsDetailsPagination}
							/>
						</ReduxBlockUi>
					</Tab>
					<Tab eventKey={2} title={t('CampaignStats_Tab_Summary')}>
						<ReduxBlockUi block={CAMPAIGN_STATS_REQUEST} unblock={[CAMPAIGN_STATS_SUCCESS, CAMPAIGN_STATS_FAILURE]}>
							<Summary
								data={data}
								onFetchData={this.handleListEventSummary}
								{...this.props.campaignStatsPagination}
							/>
						</ReduxBlockUi>
					</Tab>
				</Tabs>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		exports,
		entities: { campaignStats, campaignStatsDetails }
	} = state;

	const campaignStatsPagination = pagination.campaignStats.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const campaignStatsDetailsPagination = pagination.campaignStatsDetails.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const campaignStatsExport = exports.campaignStats.all || {};

	return {
		data: campaignStatsPagination.ids.map(id => campaignStats[id]),
		details: campaignStatsDetailsPagination.ids.map(id => campaignStatsDetails[id]),
		campaignStatsPagination,
		campaignStatsDetailsPagination,
		campaignStatsExport
	};
};

const mapDispatchToProps = {
	loadCampaignStats: loadCampaignStats,
	loadCampaignStatsDetails: loadCampaignStatsDetails,
	exportCampaignStats,
	resetFilter: () => reset('campaignStatsFilter'),
	initializeFilter: (data, fields) => initialize('campaignStatsFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CampaignStats));